import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showModal, showFadeCarregando, showAlerta, preencherListagem, atualizarDetalhes } from '@common/common.action';
import {
  fecharModal,
  liberarLaudoParcialmente,
} from './store/liberacao.action';

const Liberar = (props) => {
  const history = useHistory();
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;

  function toggle() {
    props.fecharModal(false,props.liberacaoParcialHabilitada, props.laudo);
    props.showModal(!props.modalAberto);

    if (props.isGoBack) history.goBack();
  }

  function confirmar() {
    const listagem = [...props.listagem];
    const listagemIndex = listagem.findIndex(
      item => item.laudo === props.laudo
    );
    if(listagemIndex>= 0){
      listagem[listagemIndex].dataLiberacao = new Date().toLocaleDateString();
      listagem[listagemIndex].isLaudoLiberado = true;
      listagem[listagemIndex].isLiberadoParcial = true;
      props.preencherListagem(listagem);
    }

    props.liberarLaudoParcialmente();
    props.fecharModal(false,props.liberacaoParcialHabilitada, props.laudo);
    props.showModal(false);
    props.showFadeCarregando(true);


    setTimeout(() => {
      props.showFadeCarregando(false);
      props.showAlerta('sucesso','Laudo liberado parcialmente com sucesso',2000)

      if (props.isGoBack)
        history.goBack();
      else{

        var lista= [];
        // eslint-disable-next-line array-callback-return
        props.listagem.map((item, i) => {
          if(item.laudo === props.laudo){
            item.isLiberadoParcial = true;
          }
          lista.push(item);
        })
        props.preencherListagem(lista);
      }

    }, 200);
  }

  function exibirModalLiberacaoTotal() {
    props.fecharModal(true,props.liberacaoParcialHabilitada, props.laudo);
  }

  return (
    <Modal
      size={'ie'}
      isOpen={props.modalAberto}
      toggle={toggle}
      backdrop={backdrop}
      keyboard={keyboard}
      centered
    >
      <ModalHeader toggle={props.toggle}>
        <div>Liberação parcial do Laudo</div>
      </ModalHeader>

      <div style={{ marginLeft: '15px', marginTop: '20px' }}>
        <span>Deseja liberar o laudo parcialmente?</span>
      </div>

      <ModalFooter>
        <Button color="secondary" onClick={() => exibirModalLiberacaoTotal()}>
          Não
        </Button>
        <Button color="primary" onClick={() => confirmar()}>
          Confirmar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

///export default Liberar;

const mapStateToProps = (state) => ({
  modalAberto: state.modalLiberacaoParcial.modalAberto,
  laudo: state.modalLiberacaoParcial.laudo,
  liberacaoParcialHabilitada: state.modalLiberacaoParcial.liberacaoParcialHabilitada,
  listagem: state.commonReducer.listagem,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { fecharModal, liberarLaudoParcialmente, showModal, showFadeCarregando, showAlerta, preencherListagem, atualizarDetalhes},
    dispatch

  );

export default connect(mapStateToProps, mapDispatchToProps)(Liberar);



// WEBPACK FOOTER //
// ./src/pages/laudo/modais/liberacao_parcial/index.js